// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { EMPTY_VALUE } from "@conklin/XDL/constants";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { useContext } from "react";

export interface OrderDetailsTitleStyles {
    titleText: TypographyProps;
}

export const titleStyles: OrderDetailsTitleStyles = {
    titleText: {
        variant: "h2",
        as: "h1",
    },
};

const styles = titleStyles;

const OrderDetailsTitle: React.FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    return (
        <Typography {...styles.titleText} data-test-selector="orderDetails_orderNumber">
            {/* XNG-Changes */}
            {translate("Order #") + order.erpOrderNumber}
            {/* {order.erpOrderNumber
                ? `${translate("Order #")}${order.erpOrderNumber}`
                : `${translate("Web Order #")}${order.webOrderNumber}`} */}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsTitle,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
